'use client';

import { useTranslations } from 'next-intl';
import {
  addLeadingZero,
  getLeftDays,
  getLeftHours,
  getLeftMinutes,
} from '~/utils/utils';

interface TimeLeftProps {
  endAt: string;
}

export const TimeLeft = ({ endAt }: TimeLeftProps) => {
  const t = useTranslations('GLOBAL');

  const leftDays = getLeftDays(endAt);
  const leftHours = getLeftHours(endAt);
  const leftMinutes = getLeftMinutes(endAt);
  const calMinuteInCurrentHour = leftMinutes - leftHours * 60;
  const minutesInCurrentHour = addLeadingZero(calMinuteInCurrentHour);

  return (
    <span className="time-left">
      {leftDays > 0 && (
        <span className="time-left__label">
          {t('REMAINING_DAY', {
            count: leftDays,
          })}
        </span>
      )}
      {leftDays < 1 && leftHours > 0 && (
        <span className="time-left__label">
          {t.rich('REMAINING', {
            count: leftHours,
            minutesInCurrentHour,
          })}
        </span>
      )}
      {leftMinutes && leftDays < 1 && leftHours < 1 && leftMinutes >= 0 && (
        <span className="time-left__label">
          {t.rich('REMAINING_MINUTE', {
            count: leftMinutes,
          })}
        </span>
      )}
      {leftMinutes < 0 && (
        <span className="time-left__label">
          {t('FINISHED')}
        </span>
      )}
    </span>
  );
};
